import { useEffect, useState } from "react";
import styles from "../../styles/Home.module.css";
import Camera from "../Camera";
import useScanBackDocument from "../../hooks/useScanBackDocument";
import { getScanBackColor } from "../../constants";
import Card from "../../assets/card.svg";
import { getBackDocumentStatusMessage } from "@privateid/cryptonets-web-sdk-alpha/dist/utils";

const ScanBackDocument = ({
  onSuccess,
  onReadyCallback,
  onCameraFail,
  onCameraNotFullHd,
  setOpStatus,
  setStep,
}: {
  onSuccess?: (e: any) => void;
  onReadyCallback?: (e: boolean) => void;
  onCameraFail?: (e: any) => void;
  onCameraNotFullHd?: (e: any) => void;
  setOpStatus?: (e: number) => void;
  setStep?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [isReady, setIsReady] = useState(false);

  // Scan Document Back
  const handleBackSuccess = (result: any) => {
    onSuccess?.(result);
  };
  const { scanBackDocument, barcodeStatusCode, scannedCodeData } =
    useScanBackDocument(handleBackSuccess) as any;
  const handleScanDocumentBack = async (e: boolean) => {
    setIsReady(e);
    onReadyCallback?.(e);
    if (e) {
      await scanBackDocument();
    }
  };
  useEffect(() => setOpStatus?.(scannedCodeData?.op_status), [scannedCodeData]);

  return (
    <div id="canvasInput" className={`${styles.container} documentCamera`}>
      {isReady && (
        <>
          <div
            className={styles.cameraFrame}
            style={{
              borderColor: getScanBackColor(barcodeStatusCode),
            }}
          >
            <img src={Card} alt="" />
          </div>
          <div className={styles.cameraFrameOuter} />
        </>
      )}
      <Camera
        onSwitchCamera={handleScanDocumentBack}
        onReadyCallback={handleScanDocumentBack}
        onCameraFail={onCameraFail}
        style={{ height: "unset" }}
        mode={"back"}
        requireHD={true}
        message={getBackDocumentStatusMessage(barcodeStatusCode)}
        isDocumentScan={true}
        onCameraNotFullHd={onCameraNotFullHd}
        setStep={setStep}
        hideInstructionOverlay={false}
      ></Camera>
    </div>
  );
};

export default ScanBackDocument;
